import reactionGeneral from "./reaction/general.js";
import sampleChromatogram from "./sample/chromatogram.js";
import sampleCyclicVoltammetry from "./sample/cyclicVoltammetry.js";
import sampleDifferentialCentrifugalSedimentation from "./sample/differentialCentrifugalSedimentation.js";
import sampleDifferentialScanningCalorimetry from "./sample/differentialScanningCalorimetry.js";
import sampleDls from "./sample/dls.js";
import sampleElementAnalysis from "./sample/elementAnalysis.js";
import sampleGenbank from "./sample/genbank.js";
import sampleGeneral from "./sample/general.js";
import sampleHgPorosimetry from "./sample/hgPorosimetry.js";
import sampleIcp from "./sample/icp.js";
import sampleImage from "./sample/image.js";
import sampleIr from "./sample/ir.js";
import sampleIsotherm from "./sample/isotherm.js";
import sampleIv from "./sample/iv.js";
import sampleMass from "./sample/mass.js";
import sampleNmr from "./sample/nmr.js";
import sampleOan from "./sample/oan.js";
import samplePelletHardness from "./sample/pelletHardness.js";
import samplePermeability from "./sample/permeability.js";
import samplePhysical from "./sample/physical.js";
import sampleRaman from "./sample/raman.js";
import sampleStock from "./sample/stock.js";
import sampleThermogravimetricAnalysis from "./sample/thermogravimetricAnalysis.js";
import sampleUv from "./sample/uv.js";
import sampleVideo from "./sample/video.js";
import sampleVoidVolume from "./sample/voidVolume.js";
import sampleXps from "./sample/xps.js";
import sampleXray from "./sample/xray.js";
import sampleXrd from "./sample/xrd.js";
import sampleXrf from "./sample/xrf.js";
import sampleZetaPotential from "./sample/zetaPotential.js";
const lib = {
    reaction: {
        general: reactionGeneral,
    },
    sample: {
        chromatogram: sampleChromatogram,
        cyclicVoltammetry: sampleCyclicVoltammetry,
        differentialCentrifugalSedimentation: sampleDifferentialCentrifugalSedimentation,
        differentialScanningCalorimetry: sampleDifferentialScanningCalorimetry,
        dls: sampleDls,
        elementAnalysis: sampleElementAnalysis,
        genbank: sampleGenbank,
        general: sampleGeneral,
        hgPorosimetry: sampleHgPorosimetry,
        icp: sampleIcp,
        image: sampleImage,
        ir: sampleIr,
        isotherm: sampleIsotherm,
        iv: sampleIv,
        mass: sampleMass,
        nmr: sampleNmr,
        oan: sampleOan,
        pelletHardness: samplePelletHardness,
        permeability: samplePermeability,
        physical: samplePhysical,
        raman: sampleRaman,
        stock: sampleStock,
        thermogravimetricAnalysis: sampleThermogravimetricAnalysis,
        uv: sampleUv,
        video: sampleVideo,
        voidVolume: sampleVoidVolume,
        xps: sampleXps,
        xray: sampleXray,
        xrd: sampleXrd,
        xrf: sampleXrf,
        zetaPotential: sampleZetaPotential,
    },
};
export default lib;
//# sourceMappingURL=index.js.map